import { ReactElement, ReactNode } from 'react';
import { faCheck, faExclamation, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Toast.scss';

export type ToastVariant = 'success' | 'error';

type ToastProps = {
  // Rich content is accepted so callers can embed inline links or buttons (e.g. "Learn
  // more", "undo this action"); anchors and buttons inside it are styled as links.
  // Buttons lay out as inline blocks, so wrap a button and any trailing punctuation in
  // a `text-nowrap` span to keep them on the same line.
  message: ReactNode;
  variant: ToastVariant;
  onClose: () => void;
  // Renders an "Undo this action" link after the message when provided.
  onUndo?: () => void;
};

const Toast = (props: ToastProps): ReactElement => {
  const { message, variant, onClose, onUndo } = props;

  return (
    <div
      className={`app-toast app-toast-${variant}`}
      role={variant === 'error' ? 'alert' : 'status'}
    >
      <span className="app-toast-icon">
        <FontAwesomeIcon icon={variant === 'error' ? faExclamation : faCheck} />
      </span>
      <div className="app-toast-message">
        {message}
        {onUndo && (
          <>
            {' '}
            <span className="text-nowrap">
              <button onClick={onUndo} type="button">
                Undo this action
              </button>
              .
            </span>
          </>
        )}
      </div>
      <button
        aria-label="Dismiss notification"
        className="app-toast-close"
        onClick={onClose}
        type="button"
      >
        <FontAwesomeIcon icon={faXmark} />
      </button>
    </div>
  );
};

export default Toast;
